module.exports = __webpack_public_path__ + "assets/fd9f57f1c485f13136e55e66ed797562.png";